import { render, staticRenderFns } from "./TTextAreaInput.vue?vue&type=template&id=72127560"
import script from "./TTextAreaInput.vue?vue&type=script&lang=js"
export * from "./TTextAreaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports